import React from "react";
import { Box, Grid, Typography, Divider, Link } from '@mui/material';
import { makeStyles } from '@mui/styles';

import BmsLogo from '../shared/assets/bms_logo.svg';

const useStyles = makeStyles((theme) => ({
    footer: {
        margin: "auto 20px 20px",
        textAlign: "start",
        fontSize: 16,
    },
    footerImg: {
        margin: "15px 0 10px",
        width: "225px !important"
    },
    footerText: {
        color: "#595454"
    },
    link: {
        color: "#595454"
    }
}));

const Footer = (props) => {
    const classes = useStyles();

    return (
        <Box className={classes.footer}>
            <Divider />
            <Box style={{ marginLeft: "30px" }}>
                <Link target="_blank" href="https://www.bms.com">
                    <img src={BmsLogo} className={classes.footerImg} />
                </Link>
                <Grid container spacing={2} className={classes.footerText}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px"
                            }}
                        >
                            <Link target="_blank" className={classes.link} color="inherit" href="https://www.bms.com/legal-notice.html">Legal Notice</Link>
                            <Divider orientation="vertical" variant="middle" flexItem style={{ margin: "2px 0" }} />
                            <Link target="_blank" className={classes.link} color="inherit" href="https://www.bms.com/privacy-policy.html">Privacy Policy</Link>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Typography variant='body2'>© 2024 MyoKardia, Inc., a Bristol Myers Squibb company.</Typography>
                        <Typography variant='body2'>CAMZYOS<sup>&reg;</sup> and the MyCAMZYOS Logo are trademarks of MyoKardia, Inc.</Typography>
                        <Typography variant='body2'>This website is intended for U.S. residents 18 years of age or older.</Typography>
                        <Typography variant='body2'>3500-US-2400229 04/24</Typography>
                    </Grid>
                </Grid>
            </Box>
        </Box >
    );
}

export default Footer;